var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.currentTab.value,
            callback: function ($$v) {
              _vm.$set(_vm.currentTab, "value", $$v)
            },
            expression: "currentTab.value",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "线上数据", name: "online" } }),
          _c("el-tab-pane", { attrs: { label: "本地数据", name: "local" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }